import type { MeResponse } from '@staiter/shared';

/**
 * ACC-F1 (пак `tails-closeout`, найдено на кадре F10, 18.09.2026) — после смены
 * компании перечитать `/auth/me`.
 *
 * `module_access` живёт в `useAuthStore.user.scope` и приходил только при загрузке
 * страницы. Смена компании пересоздавала кэш запросов, но не профиль — и меню,
 * `ModuleGuard` и кнопка чата гейтились по списку модулей ПРЕЖНЕЙ компании до
 * перезагрузки: из компании без модуля в компанию с ним — раздел прятался; обратно —
 * показывался и падал 403.
 *
 * Ответ, пришедший после следующей смены компании, отбрасывается: иначе медленный
 * ответ по компании A перезаписал бы профиль уже выбранной компании B.
 */
export function createMeRefresher(deps: {
  fetchMe: () => Promise<MeResponse>;
  setMe: (me: MeResponse) => void;
}): () => Promise<void> {
  let generation = 0;
  return async () => {
    generation += 1;
    const mine = generation;
    try {
      const me = await deps.fetchMe();
      if (mine === generation) deps.setMe(me);
    } catch {
      // Профиль не перечитался — остаётся прежний; сетевой отказ покажет общий
      // обработчик запросов, а 401 уведёт на вход штатным путём.
    }
  };
}
